<template>
  <div style="max-width: 750px;margin: 0 auto">
    <div class="pd-10">
      <div>课程信息</div>
      <div class="align-items-center mg-t-10">
        <img src="static/images/course/buy_image.png" class="bg-e8e w-110 h-62"/>
        <div class="column pd-15 justify-content-space-between">
          <div class="fs-16 text-strong">Anki入门到精通，助考试提分</div>
          <div class="c-app-orange fs-22">
            ￥ {{originAmount}}
            <span class="fs-12 text-delete c-9">原价￥ 199</span>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-f3f h-10"></div>

    <van-cell-group>
      <van-field v-model="phone" label="手机号" placeholder="请输入手机号" error-message=""/>
      <van-field v-model="smsCode" type="number" center clearable label="短信验证码" placeholder="请输入短信验证码">
        <template #button>
          <van-button size="small" class="w-90" style="background-color: #EBF4FF" @click="sendSMS">{{smsTxt}}
          </van-button>
        </template>
      </van-field>
      <van-field @click="onCouponClick" readonly v-model="couponCode" label="折扣码" placeholder="输入折扣码(选填)"/>
    </van-cell-group>
    <div class="pd-20">
      <div class="text-align-center">实付：
        <span class="fs-24 c-app-orange">￥{{amount}}</span>
        <span v-if="couponRate" class="fs-12 c-app-orange mg-l-20">(已优惠{{couponRate}}折￥{{couponMoney}})</span>
      </div>
      <div @click="onPayClick"
           class="bg-app-blue c-f justify-content-center w-fill align-items-center pd-t-10 pd-b-10 bdr-40 mg-t-10">
        <img width="30" class="mg-r-10" src="static/images/course/buy_zhifubao.png"/>
        支付宝支付
      </div>
      <div @click="onSearchClick" class="mg-t-20 c-app-navy fs-12 text-align-center">已支付，查询购课信息&gt;</div>
    </div>

    <van-popup v-model="inputCouponCode">
      <div class="pd-20 w-300">
        <h3 class="text-align-center">查询折扣</h3>
        <van-cell-group>
          <van-field input-align="center" v-model="couponCode" placeholder="请输入折扣码"/>
        </van-cell-group>
        <div class="display-flex mg-t-20">
          <div @click="onInputCouponCodeCancel" class="flex-1 text-align-center pd-5">
            取消
          </div>
          <div @click="onSearchCouponClick" class="flex-1 text-align-center pd-5 c-app-navy">
            查询
          </div>
        </div>
      </div>
    </van-popup>
    <div v-if="showMask" class="position-fixed t-0 b-0 w-fill" style="background-color: rgba(0,0,0,0.8)">
      <div class="text-align-right pd-10">
        <img src="static/images/course/arrow.png" width="100">
      </div>
      <div class="text-align-center pd-10 c-f">
        <div>点击右上角</div>
        <div>微信内不支持支付宝付款</div>
        <div>请通过浏览器打开页面，再点击购买</div>
      </div>
    </div>
  </div>
</template>

<script>
  import request from '../../libs/api.request'
  import {Dialog} from 'vant';

  export default {
    name: "Course-Pay",
    data() {
      return {
        phone: '',
        smsCode: '',
        couponCode: '',
        smsTxt: '发送验证码',
        inputCouponCode: false,
        originAmount: 69,
        amount: 69,
        couponRate: '',
        couponMoney: '',
        showMask: false
      }
    },
    methods: {
      onCouponClick() {
        this.inputCouponCode = true;
      },

      isMobile() {
        return /windows phone|iphone|android/ig.test(window.navigator.userAgent)
      },

      onSearchCouponClick() {
        if (this.couponCode.length <= 5) {
          this.$toast('折扣码有误');
          return;
        }

        request.request({
          url: 'course/getCoupon',
          params: {couponCode: this.couponCode},
        }).then(data => {
          if (data) {
            this.couponRate = data.rate;
            this.couponMoney = data.couponMoney;
            this.amount = data.amount;
            this.inputCouponCode = false;
          } else {
            this.$toast('未查询到优惠信息！');
          }
        }).catch(e => {
          this.$toast(e.message)
        })
      },

      onInputCouponCodeCancel() {
        this.inputCouponCode = false;
        this.couponCode = '';
      },

      onSearchClick() {
        if (this.phone.length != 11) {
          this.$toast('请输入正确的手机号');
          return;
        }

        if (this.smsCode.length != 6) {
          this.$toast('请输入正确的验证码');
          return;
        }

        request.request({
          url: 'course/queryOrder',
          method: 'post',
          data: {
            phone: this.phone, smsCode: this.smsCode,
            returnUrl: encodeURIComponent(location.href)
          },
        }).then((data) => {
          localStorage.setItem('course-order-id', data.orderId);
          localStorage.setItem('course-phone', data.phone);
          this.$router.push({path: '/course-order', query: data});
        }).catch((e) => {
          this.$toast(e.message)
        });
      },
      onPayClick() {
        if (this.phone.length != 11) {
          this.$toast('请输入正确的手机号');
          return;
        }

        if (this.smsCode.length != 6) {
          this.$toast('请输入正确的验证码');
          return;
        }

        request.request({
          url: 'course/createOrder',
          method: 'post',
          data: {
            phone: this.phone,
            smsCode: this.smsCode,
            couponCode: this.couponCode,
            isMobile: this.isMobile() ? 1 : 0
          },
        }).then((data) => {
          location.href = data.payUrl;
        }).catch((e) => {
          this.$toast(e.message)
        });
      },
      sendSMS() {
        if (this.smsTxt != '发送验证码') {
          return;
        }

        if (this.phone.length != 11) {
          this.$toast('请输入正确的手机号');
          return;
        }

        let time = 60;
        request.request({
          url: 'course/sendSMS',
          method: 'post',
          data: {phone: this.phone},
          success: (data) => {
            this.$toast('验证码已发送');
          }
        });

        this.smsTxt = time + 's';
        let interval = setInterval(() => {
          time--;
          this.smsTxt = time + 's';
          if (time <= 0) {
            clearInterval(interval);
            this.smsTxt = '发送验证码'
          }
        }, 1000)
      },
    },
    mounted() {
      var ua = navigator.userAgent.toLowerCase();//获取判断用的对象
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        this.showMask = true;
      }
    }
  }
</script>

<style scoped>

</style>
